import { Container } from 'react-bootstrap';
import { CardUpdatePortal } from '../cardUpdatePortal';
import './accountCardUpdate.scss';
import { formatDate, useGetScreenSize } from 'utils';
import { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { PaymentSuccessPage } from './paymentSuccessPage';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useEffect, useState } from 'react';
import { PaymentInformation } from './paymentInformation';
import { clearPaymentSuccessAction, getPaymentGuidAction } from 'actions/index';
import { PageNavigation } from 'components/layout/navigation/pageNavigation';
import { PATH } from 'interfaces/pathTypes';
import { Title } from 'components/layout/header/title';

export const AccountCardUpdate = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const { isMobile, isTablet } = useGetScreenSize();
  const [showPaymentPortal, setShowPaymentPortal] = useState(false);
  const dispatch = useAppDispatch();
  const { cardNumber, cardExpiry } = selectedPolicy;
  const cardLastFourDigits = useAppSelector((state) => state.payments.cardLastFour);
  const cardExpiryDate = useAppSelector((state) => state.payments.cardExpiry);
  const formattedCardExpiry = formatDate(cardExpiry, 'MM/yyyy');
  const authentication = useAppSelector((state) => state.authentication);
  const { isAgent, email } = authentication;
  const { policyDetailsId, historyId } = selectedPolicy;

  const handleClickEdit = () => {
    setShowPaymentPortal(false);
    dispatch(clearPaymentSuccessAction());

    dispatch(
      getPaymentGuidAction({
        selectedPolicy,
        amount: 0.01,
        source: 'ReplaceCard',
        username: email,
        isAgent,
        policyDetailsId,
        historyId
      })
    );
    setShowPaymentPortal(true);
  };

  useEffect(() => {
    return () => {
      // Called when component unmounts
      dispatch(clearPaymentSuccessAction());
    };
  }, []);

  return (
    <Container className="page-container" fluid={isMobile || isTablet}>
      <Title title="MANAGE PAYMENTS" icon="credit-card-circle" id="card-update" />
      <div className="payment-container">
        {showPaymentPortal ? (
          <CardUpdatePortal
            cardUpdateSuccessPage={
              <PaymentSuccessPage
                handleClickEdit={handleClickEdit}
                cardNumber={cardLastFourDigits}
                cardExpiry={cardExpiryDate}
              />
            }
            buttonText="Save"
            subHeadingText="EDIT YOUR CARD"
          />
        ) : (
          <PaymentInformation
            handleClickEdit={handleClickEdit}
            cardNumber={cardLastFourDigits || cardNumber}
            cardExpiry={cardExpiryDate || formattedCardExpiry}
          />
        )}
      </div>
      <PageNavigation page={PATH.PAYMENT_MANAGEMENT} />
    </Container>
  );
};
